import { render, staticRenderFns } from "./TableRedAssets.vue?vue&type=template&id=dd0104c6&scoped=true"
import script from "./TableRedAssets.vue?vue&type=script&lang=js"
export * from "./TableRedAssets.vue?vue&type=script&lang=js"
import style0 from "./TableRedAssets.vue?vue&type=style&index=0&id=dd0104c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0104c6",
  null
  
)

export default component.exports